import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaSave } from "react-icons/fa";
import { settingsService, Settings } from "../../services/firebase";
import "./Settings.css";

const AdminSettings: React.FC = () => {
  const { t } = useTranslation();
  const [settings, setSettings] = useState<Settings>({
    siteName: "",
    siteDescription: "",
    contactEmail: "",
    contactPhone: "",
    socialMedia: {},
  });
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState<{
    type: "success" | "error";
    text: string;
  } | null>(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await settingsService.get();
        setSettings(data);
      } catch (error) {
              }
    };

    fetchSettings();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage(null);

    try {
      await settingsService.update(settings);
      setMessage({ type: "success", text: "ההגדרות נשמרו בהצלחה!" });
    } catch (error) {
            setMessage({ type: "error", text: "שגיאה בשמירת ההגדרות. נסה שוב." });
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (field: keyof Settings, value: any) => {
    setSettings((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="settings-page-container">
      <div className="settings-header">
        <h1 className="settings-title">{t("admin.settings")}</h1>
        <p className="settings-description">
          ההגדרות כאן ישפיעו על כל האייקונים החברתיים באתר. וואטסאפ ישתמש במספר
          הטלפון שהוזן.
        </p>
      </div>

      {message && (
        <div className={`settings-message ${message.type}`}>{message.text}</div>
      )}

      <form className="settings-form" onSubmit={handleSubmit}>
        <div className="settings-section">
          <h2 className="settings-section-title">
            {t("admin.generalSettings")}
          </h2>
          <div className="settings-form-group">
            <label className="settings-label">{t("admin.siteName")}</label>
            <input
              className="settings-input"
              type="text"
              value={settings.siteName}
              onChange={(e) => handleChange("siteName", e.target.value)}
            />
          </div>
    
        </div>

        <div className="settings-section">
          {/* <h2 className="settings-section-title">
            {t("admin.contactSettings")}
          </h2>
          <div className="settings-form-group">
            <label className="settings-label">{t("admin.email")}</label>
            <input
              className="settings-input"
              type="email"
              value={settings.contactEmail}
              onChange={(e) => handleChange("contactEmail", e.target.value)}
            />
          </div> */}
          <div className="settings-form-group">
            <label className="settings-label">
              {t("admin.phone")} (לשימוש בוואטסאפ)
            </label>
            <input
              className="settings-input"
              type="tel"
              value={settings.contactPhone}
              onChange={(e) => handleChange("contactPhone", e.target.value)}
              placeholder="+972-50-123-4567"
            />
            <small className="settings-small-text">
              מספר הטלפון ישמש ליצירת קישור וואטסאפ אוטומטי
            </small>
          </div>
        </div>

        <div className="settings-section">
          <h2 className="settings-section-title">{t("admin.socialMedia")}</h2>
          <p className="settings-section-description">
            הקישורים כאן ישפיעו על כל האייקונים החברתיים באתר. וואטסאפ ישתמש
            במספר הטלפון שהוזן בחלק הקודם.
          </p>
          <div className="settings-form-group">
            <label className="settings-label">Facebook</label>
            <input
              className="settings-input"
              type="url"
              value={settings.socialMedia.facebook || ""}
              onChange={(e) =>
                handleChange("socialMedia", {
                  ...settings.socialMedia,
                  facebook: e.target.value,
                })
              }
              placeholder="https://facebook.com/yourpage"
            />
          </div>
          <div className="settings-form-group">
            <label className="settings-label">Instagram</label>
            <input
              className="settings-input"
              type="url"
              value={settings.socialMedia.instagram || ""}
              onChange={(e) =>
                handleChange("socialMedia", {
                  ...settings.socialMedia,
                  instagram: e.target.value,
                })
              }
              placeholder="https://instagram.com/yourprofile"
            />
          </div>
        </div>

        <button
          className="settings-save-button"
          type="submit"
          disabled={isLoading}
        >
          <FaSave />
          {isLoading ? t("common.loading") : t("admin.saveSettings")}
        </button>
      </form>
    </div>
  );
};

export default AdminSettings;
